import type { JourneyPhase } from '@/types/brand'
import type { SearchIntent } from '@/types/search-intent'

/** The locale key of each journey phase's name. */
export const PHASE_LABEL_KEYS: Record<JourneyPhase, string> = {
  awareness: 'brand.beliefMap.phases.awareness.name',
  consideration: 'brand.beliefMap.phases.consideration.name',
  decision: 'brand.beliefMap.phases.decision.name',
}

/** Mirrors the server's `journeyPhaseForSearchIntent`: awareness for informational, consideration for commercial, decision for transactional, `null` for navigational. */
export function journeyPhaseForSearchIntent(intent: SearchIntent): JourneyPhase | null {
  switch (intent) {
    case 'informational':
      return 'awareness'
    case 'commercial':
      return 'consideration'
    case 'transactional':
      return 'decision'
    case 'navigational':
      return null
  }
}
